import * as Sentry from '@root/vendor/@sentry/browser';
import environment from '@root/core/src/utils/environment';

export default class SentryInitializer {
  static init() {
    Sentry.init({
      dsn: environment.sentryDsn,
      release: environment.releaseSha,
      environment: process.env.NODE_ENV,
    });
  }
}
